import { subscribe } from 'diagnostics_channel';
import { Component, EventEmitter, Input, Output, SimpleChanges, AfterViewInit } from '@angular/core';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { PriceValues } from 'src/app/services/payment/methods/methods.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { SwiperOptions } from 'swiper';
import { log } from 'console';


@Component({
  selector: 'app-price-value-carousel',
  templateUrl: './price-value-carousel.component.html',
  styleUrls: ['./price-value-carousel.component.scss']
})
export class PriceValueCarouselComponent extends BasePageComponent {

  selectedPriceValue: number;

  constructor(
    public detectDeviceService: DetectDeviceService,
  ) { super() }

  _priceValues: PriceValues;
  @Input()
  set priceValues(value: PriceValues) {
    this._priceValues = value
  };

  get priceValues() {
    return this._priceValues;
  }
  @Input() currency: string;
  @Input() currentValue: number;
  @Output() selectedPrice = new EventEmitter<number>();

  config: SwiperOptions = {
    direction: 'horizontal',
    slideToClickedSlide: false,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    keyboard: true,
    freeMode: true,
    slidesPerView: 3,
    centeredSlides: false,
    loop: false,
    simulateTouch: false,
    roundLengths: true
  };

  ngOnInit(): void {
    if (this.detectDeviceService.isDesktop()) {
      this.config.slidesPerView = 5;
      this.config.simulateTouch = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentValue && changes.currentValue.currentValue !== undefined) {
      const existingAmount = this._priceValues.find((price) => price.value === Number.parseInt(changes.currentValue.currentValue.toString()));
      if (existingAmount) {
        this.selectedPriceValue = existingAmount.value;
        this.selectedPrice.next(existingAmount.value);
      } else {
        this.selectedPriceValue = null;
      }
    }
  }

  ngAfterViewInit() {
    if (this.currentValue && this.currentValue !== undefined) {
      const existingAmount = this._priceValues.find((price) => price.value === Number.parseInt(this.currentValue.toString()));
      if (existingAmount) {
        this.selectedPriceValue = existingAmount.value;
        this.selectedPrice.next(existingAmount.value);
      } else {
        this.selectedPriceValue = null;
      }
    }
  }

  selectPrice(event, price) {
    this.selectedPriceValue = price;
    this.selectedPrice.next(price);
  }

}
